import { FETCH_PRODUCTS, SET_GRADE, SET_EMAIL, SET_OFFER_DATA, SET_VARIANT, SET_SETTINGS, SET_SHOW_GRADE_SELECTION_POPUP, SET_SHOW_MORE_PLANS, SET_PRODUCTS, SET_PROMO_CODE, SET_COUPONS } from "./actionType";
import { CatalogProducts, OfferData, SemSettings } from "../../../app/js/services/loggedout-api"

export const getCatalogProducts = async (params) => {
  const action = { type: FETCH_PRODUCTS, payload: {} };
  try {
    const response = await CatalogProducts(params);
    const products = response.products.map(product => {
      const credit_count = (product.credit_products && product.credit_products.length && product.credit_products[0].credits_count) || 1;
      return { ...product, credit_count };
    });
    action.payload = products || [];
    return action;
  } catch (err) {
    console.error(err);
    return action;
  }
}

// For setting up a particular product rather than setting it up from the Catalog API
export const setProducts = products => {
  const modifiedProducts = products.map(product => {
    const credit_count = (product.credit_products && product.credit_products.length && product.credit_products[0].credits_count) || 1;
    return { ...product, credit_count };
  });
  return {
    type: SET_PRODUCTS,
    payload: modifiedProducts
  }
}

export const setGrade = grade => {
  return {
    type: SET_GRADE,
    payload: grade
  }
}

export const setEmail = email => {
  return {
    type: SET_EMAIL,
    payload: email
  }
}

export const setOfferData = async (params) => {
  const action = { type: SET_OFFER_DATA, payload: {} };
  try {
    const response = await OfferData(params);
    action.payload = response;
    return action;
  } catch (err) {
    console.error(err);
    return action;
  }
}

export const setVariant = variant => {
  return {
    type: SET_VARIANT,
    payload: variant
  }
}

export const setSemSettings = async (params) => {
  try {
    const res = await SemSettings(params);
    return {
      type: SET_SETTINGS,
      payload: res
    };
  } catch (err) {
    console.error(err);
    return {
      type: SET_SETTINGS,
      payload: "en"
    }
  }
}

export const setShowGradeSelectionPopup = (value) =>{
  return {
    type: SET_SHOW_GRADE_SELECTION_POPUP,
    payload: value
  }
}

export const setShowMorePlans = (value) =>{
  return {
    type: SET_SHOW_MORE_PLANS,
    payload: value
  }
}

export const setPromoCodeInContext = promoCode => {
  return {
    type: SET_PROMO_CODE,
    payload: promoCode
  }
}

export const updateSettings = data =>{
  return {
    type: SET_SETTINGS,
    payload: data
  };
}

export const setCoupons = data =>{
  return {
    type: SET_COUPONS,
    payload: data
  }
}